import {
  INVOICES_ALL,
  INVOICES_ALL_SUCCESS,
  INVOICES_CREATE,
  INVOICES_CREATE_SUCCESS,
  INVOICES_DELETE,
  INVOICES_DELETE_SUCCESS,
  INVOICES_GET,
  INVOICES_GET_ACCESS_CODE,
  INVOICES_GET_ACCESS_CODE_SUCCESS,
  INVOICES_GET_ALL,
  INVOICES_GET_ALL_SUCCESS,
  INVOICES_GET_SUCCESS,
  INVOICES_SET_BOARD_COLUMNS,
  INVOICES_SET_BOARD_DATA,
  INVOICES_SET_BOARD_ORDERED,
  INVOICES_SET_MODIFIED_INVOICE,
  INVOICES_STATUSES,
  INVOICES_STATUSES_SUCCESS,
  INVOICES_UPDATE,
  INVOICES_UPDATE_PAGINATION,
  INVOICES_UPDATE_SUCCESS,
} from 'redux/constants/Invoices';

export const getInvoices = (perPage, page, startDate, endDate, statusId) => {
  return {
    type: INVOICES_ALL,
    perPage,
    page,
    startDate,
    endDate,
    statusId,
  };
};

export const getInvoicesSuccess = (
  invoices,
  total,
  from,
  to,
  startDate,
  endDate,
  statusId
) => {
  return {
    type: INVOICES_ALL_SUCCESS,
    invoices,
    total,
    from,
    to,
    startDate,
    endDate,
    statusId,
  };
};

export const getAllInvoices = () => {
  return {
    type: INVOICES_GET_ALL,
  };
};

export const setBoardData = (ordered, columns) => ({
  type: INVOICES_SET_BOARD_DATA,
  ordered,
  columns,
});

export const setBoardOrdered = (ordered) => ({
  type: INVOICES_SET_BOARD_ORDERED,
  ordered,
});

export const setBoardColumns = (columns) => ({
  type: INVOICES_SET_BOARD_COLUMNS,
  columns,
});

export const setModifiedInvoice = (invoice) => ({
  type: INVOICES_SET_MODIFIED_INVOICE,
  invoice,
});

export const getInvoice = (id) => {
  return {
    type: INVOICES_GET,
    id,
  };
};

export const getInvoiceSuccess = (invoice) => {
  return {
    type: INVOICES_GET_SUCCESS,
    invoice,
  };
};

export const getInvoiceByAccessCode = (id, accessCode) => {
  return {
    type: INVOICES_GET_ACCESS_CODE,
    id,
    accessCode,
  };
};

export const getInvoiceByAccessCodeSuccess = (invoice) => {
  return {
    type: INVOICES_GET_ACCESS_CODE_SUCCESS,
    invoice,
  };
};

export const getAllInvoicesSuccess = (invoices, total) => {
  return {
    type: INVOICES_GET_ALL_SUCCESS,
    invoices,
    total,
  };
};

export const createInvoice = (data, history) => {
  return {
    type: INVOICES_CREATE,
    data,
    history,
  };
};

export const createInvoiceSuccess = (invoice) => {
  return {
    type: INVOICES_CREATE_SUCCESS,
    invoice,
  };
};

export const updateInvoice = (id, data, history) => {
  return {
    type: INVOICES_UPDATE,
    id,
    data,
    history,
  };
};

export const updateInvoiceSuccess = (id, invoice) => {
  return {
    type: INVOICES_UPDATE_SUCCESS,
    id,
    invoice,
  };
};

export const updateInvoicesPagination = (perPage, page) => ({
  type: INVOICES_UPDATE_PAGINATION,
  perPage,
  page,
});

export const deleteInvoice = (id, history) => {
  return {
    type: INVOICES_DELETE,
    id,
    history,
  };
};

export const deleteInvoiceSuccess = (id) => {
  return {
    type: INVOICES_DELETE_SUCCESS,
    id,
  };
};

export const getInvoiceStatuses = () => {
  return {
    type: INVOICES_STATUSES,
  };
};

export const getInvoiceStatusesSuccess = (statuses) => {
  return {
    type: INVOICES_STATUSES_SUCCESS,
    statuses,
  };
};
